<template>
  <div>
    <Modal
      v-model="openForm"
      :title="'网格人员分派 / '+item.userList.length+'人'"
      footer-hide
      width="700"
      @on-cancel="cliclCancelBtn"
    >
      <ly-group>
        <ly-item v-for="(x, index) in item.userList" :key="index"
          >{{ x.name
          }}<Icon
            @click="item.userList.splice(index, 1)"
            type="ios-backspace-outline"
        /></ly-item>
      </ly-group>
      <div class="clearfloat" style="widthL100%">
        <div style="float: left">
          <Button @click="openPerson = true">新增人员</Button>
          <Button @click="item.userList = []">清空人员</Button>
        </div>
        <div style="float: right">
          <Button
            type="primary"
            @click="save"
            >提交保存</Button
          >
        </div>
      </div>
    </Modal>
    <Drawer
      title="请选择人员"
      placement="right"
      :closable="true"
      v-model="openPerson"
      draggable
      class="my-drawer"
      width="450"
    >
      <personTool v-if="openPerson" @persons="rePersons" :isMore="true"></personTool>
    </Drawer>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openForm: false,
      openPerson: false,
      gridItem: {},
      item: {
        gridId: "10",
        userList: [
          /*           {
            accountId: "zsces",
            name: "刘子健",
            userId: "1534778433519026178",
          }, */
        ],
        groupId: "6",
      },
    };
  },
  methods: {
    open(v) {
      console.log(v);
      this.gridItem = v;
      this.item.gridId = v.id;
      this.item.groupId = v.groupId;
      this.openForm = true;
      this.getList();
    },
    getList() {
      this.item.userList = [];
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.swm + "/gridPerson/allUser",
        data: { gridId: this.gridItem.id,groupId:'-1' },
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载

        if (res.data.data == null) {
          return;
        }
        var data = res.data.data.userList;

        for (const i in data) {
          data[i].key = data[i].userId;
        }
        this.item.userList = data;
      });
    },
    rePersons(v) {
      console.log(v);
      for (let i = 0; i < v.length; i++) {
        var obj = {
          accountId: v[i].userAccount,
          name: v[i].name,
          userId: v[i].id,
          key: v[i].id,
        };
        this.item.userList.unshift(obj);
      }

      this.item.userList = this.utils.qcArr(this.item.userList);
    },
    cliclCancelBtn() {},
    save() {
      console.log(this.item);
      axios({
        method: "post",
        url: axios.swm + "/gridPerson/assignUser",
        data: this.item,
      }).then((res) => {
        console.log(res);
        if (res.data.code != 200) {
          this.$Message.error(res.data.message);
        } else {
          this.openForm = false;
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/person/personList.vue